const Index = () => import(/* webpackChunkName: "proj" */ './Index');

export default {
  routes: [
    {
      path: '/proj/inco_claim_split/index',
      name: 'proj_inco_claim_split_index',
      component: Index
    }
  ]
}
